import Image from 'next/image'
import React, { useState, useLayoutEffect, ReactNode } from 'react'
import { CookieKeys, getCookie, setCookie } from 'services/Cookies'
import { Onboarding } from '../Onboarding'
import { LoginLayoutRoot, Wrapper, Content, MeatPattern } from './LoginLayout.styles'

import loginPattern from '/public/assets/pattern-login-01.webp'

type LoginLayoutProps = {
  skipOnboarding?: boolean
  children?: ReactNode
}

export const LoginLayout: React.FC<LoginLayoutProps> = ({ children, skipOnboarding = false }) => {
  return (
    <Wrapper>
      <LoginLayoutRoot gap="0" justifyContent="center" alignItems="center">
        <Content>{children}</Content>
      </LoginLayoutRoot>
    </Wrapper>
  )
}

LoginLayout.displayName = 'LoginLayout'
